export default "__VITE_ASSET__CJBLsrUT__"